// extracted by mini-css-extract-plugin
export default {"textWrap":"ExcluiArquivo_textWrap__ozhbT","margin":"ExcluiArquivo_margin__vKCes"};